{
  "version": 1,
  "asset_id": "633c3dce-5e3d-40e1-bb64-84be12ce4def",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/633c3dce-5e3d-40e1-bb64-84be12ce4def/hiatal-type-4-es-v3-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/633c3dce-5e3d-40e1-bb64-84be12ce4def/hiatal-type-4-es-v3-1200.webp",
  "original_filename": "hiatal-type-4-es-v3-1200.webp",
  "size": 188120,
  "content_type": "image/webp",
  "created_at": "2026-10-28T23:03:53Z"
}
